class Post {
    id;
    title;
    content;
    contentImageURL;
    publicationDate;
    author;
    segments;
    images;
    isSeen;
    constructor(postData) {
        this.id = postData.id;
        this.title = postData.title;
        this.content = postData.content;
        this.contentImageURL = postData.contentImageURL;
        this.publicationDate = new Date(postData.publicationDate);
        this.author = postData.author;
        this.segments = postData.segments;
        this.images = Array.isArray(postData.images) ? postData.images : [];
        this.isSeen = false;
    }
    getGalleryImages() {
        const filteredUrls = this.images
            .filter(image => image?.url)
            .map(image => image.url);
        return [this.contentImageURL, ...filteredUrls];
    }
    hasImages() {
        return this.getGalleryImages().length > 1;
    }
    markAsSeen() {
        this.isSeen = true;
    }
    markAsUnseen() {
        this.isSeen = false;
    }
    isPostSeen() {
        return this.isSeen;
    }
}
export default Post;
